import { render, staticRenderFns } from "./CompanyHome.vue?vue&type=template&id=62f1a720&scoped=true"
import script from "./CompanyHome.vue?vue&type=script&lang=js"
export * from "./CompanyHome.vue?vue&type=script&lang=js"
import style0 from "./CompanyHome.vue?vue&type=style&index=0&id=62f1a720&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f1a720",
  null
  
)

export default component.exports